var util = require("../util"), constants = require("../common/constants"), TIMING_KEYS = constants.TIMING_KEYS;

module.exports = function(e, t) {
    function r(e, r) {
        if (e instanceof t.PerformanceResourceTiming && e.initiatorType) {
            var n = util.getResType(e.initiatorType, e.name), i = r.resourceTypes || [], o = (r.ignore || {}).ignoreResources;
            if (n && i.includes(n) && !util.ignoreByRule(e.name, o) && !util.ignoreByRule(util.decode(e.name), o)) {
                var s = e[TIMING_KEYS[0]], u = e[TIMING_KEYS[1]], a = e[TIMING_KEYS[2]], c = e[TIMING_KEYS[3]], d = e[TIMING_KEYS[4]], l = e[TIMING_KEYS[5]], _ = e[TIMING_KEYS[6]], f = e[TIMING_KEYS[7]], m = e[TIMING_KEYS[8]], p = e[TIMING_KEYS[18]], h = e[TIMING_KEYS[19]];
                if (util.areInOrder(s, u, a, c, d, l, _, f, m) && (p < s && (p = s), h < s && (h = u), 
                util.areInOrder(s, p, h, u) && !(s > f))) {
                    return {
                        domain: util.getURL(e.name).domain,
                        res_type: n,
                        src_type: util.getSrcType(e.name, r.cdnHostList),
                        success: 1,
                        size: Math.round(e.decodedBodySize),
                        duration: Math.round(e.duration),
                        timeStamp: e.responseEnd,
                        timing: e
                    };
                }
            }
        }
    }
    var n = "_resource-" + Date.now(), i = "_resource_error-" + Date.now();
    util.ext(e.prototype, {
        initResource: function() {
            var e = this, r = t.performance, n = t.PerformanceObserver;
            if (e[i] || (e[i] = new WeakMap()), !r || !n || "object" != typeof r || "function" != typeof r.getEntriesByType) return null;
            var o = r.getEntriesByType("resource") || [];
            e.setResource(o);
            return new n(function(t) {
                e.setResource(t.getEntries());
            }).observe({
                entryTypes: [ "resource" ]
            }), this.onReady(function() {
                setTimeout(e.resourceComboReport.bind(e), 5e3);
            }), e;
        },
        setResource: function(e) {
            var t = this._conf;
            if (util.isArray(e) && e.length) {
                this[n] || (this[n] = {});
                for (var i = this[n], o = 0, s = e.length; o < s; o += 1) {
                    var u = e[o];
                    if (util.checkAPI(u.name, !1)) {
                        var a = r(u, t);
                        if (a) {
                            var c = a.res_type + "-" + a.domain;
                            c in i || (i[c] = []), i[c].push(a);
                        }
                    }
                }
                return this;
            }
        },
        fixResourceStatus: function(e) {
            var r = t.performance;
            if (!r || "function" != typeof r.getEntriesByName) return null;
            var n = this[i];
            if (!e.src || !util.checkAPI(e.src, !1)) return this;
            var o = e.timeStamp || r.now(), s = r.getEntriesByName(e.src, "resource");
            return util.each(s, function(e) {
                if (!n.has(e)) {
                    o - e.responseEnd < 100 && n.set(e, {
                        success: 0
                    });
                }
            }), this;
        },
        resourceComboReport: function() {
            var e = this[n] || {}, r = this._conf.resourceSlow || 2e3, o = this[i];
            this[n] = {};
            var s = Object.keys(e);
            if (0 !== s.length) {
                var u = [];
                util.each(s, function(t) {
                    var n = e[t], i = {
                        domain: "",
                        res_type: "",
                        src_type: "",
                        size: 0,
                        duration: 0,
                        count: 0,
                        err_count: 0,
                        err_duration: 0,
                        slow_count: 0,
                        slow_duration: 0,
                        timings: []
                    };
                    util.each(n, function(e) {
                        var t = e.timing || {}, n = o.get(e.timing), s = n ? n.success : 1, u = e.duration > r ? 1 : 0;
                        i.domain = e.domain, i.res_type = e.res_type, i.src_type = e.src_type, i.count += 1, 
                        i.duration += e.duration, i.size += e.size, s || (i.err_count += 1, i.err_duration += e.duration), 
                        u && (i.slow_count += 1, i.slow_duration += e.duration);
                        try {
                            var a = JSON.parse(JSON.stringify(t));
                            a.success = s, a.resourceSlow = r, a.isSlow = u, i.timings.push(a);
                        } catch (c) {}
                    }), i.count && (i.size = Math.round(i.size / i.count), i.duration = Math.round(i.duration / i.count)), 
                    i.slow_count && (i.slow_duration = Math.round(i.slow_duration / i.slow_count)), 
                    i.err_count && (i.err_duration = Math.round(i.err_duration / i.err_count)), i.timings.length > 20 && (i.timings.sort(function(e, t) {
                        return t.duration - e.duration;
                    }), i.timings.length = 20), i.timings = encodeURIComponent(JSON.stringify(i.timings)), 
                    u.push(i);
                });
                var a = {
                    _combo: 1,
                    resource: JSON.stringify(u)
                }, c = t.navigator.connection;
                a.ct = c ? c.effectiveType || c.type : "";
                var d = c ? c.downlink || c.downlinkMax || c.bandwidth || null : null;
                (d = d > 999 ? 999 : d) && (a.bandwidth = d), this._lg("resource", a, this.getConfig("sample"));
            }
        }
    });
};